import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Boleto } from '../models/Boleto';
import { MyHttpGetService } from '../services/http.services.token';
import { LocalstorageService } from '../services/localstorage.service';
import { SessionstorageService } from '../services/sessionstorage.service';
import { TimerService } from '../timer/timer.service';
import * as CryptoJS from 'crypto-js';
import { BoletosColaboradoresService } from '../boletos-colaboradores/services/boletos-colaboradores.service';
import { StripePagoService } from '../services/stripe-pago.service';
/** END Cambios Luis Aguilar WECODE */

@Component({
  selector: 'app-boletos-colaboradores-carrito',
  templateUrl: './boletos-colaboradores-carrito.component.html',
  styleUrls: ['./boletos-colaboradores-carrito.component.scss'],
  providers: [MyHttpGetService, LocalstorageService],
})
export class BoletosColaboradoresCarritoComponent implements OnInit, OnDestroy {
  //boletos_generados -> Boletos de publico general.
  //boletos_recomendados -> Boletos recomendados de un colaborador especifico.
  //boletos_asignados -> Boletos de un comprador previo.
  //boletos_bloqueados -> Array de boletos a bloquear para el cliente por un periodo de 15min.
  //boletos - > Boletos a mostrar en carrito de compra.
  //tipos_pago -> Metodos de pago a mostrar seg�n el tipo de sesi�n (1 -> PublicoGeneral, 2 -> Colaborador desde APP, 3 -> Colaborador desde PC)

  /////////////////////////

  public boletos_generados: Array<Boleto> = [];
  public boletos_recomendados: Array<Boleto> = [];
  public boletos_asignados: Array<Boleto> = []; //
  public boletos_bloqueados_local: Array<Boleto> = [];
  public boletos_bloqueados: { boletos: Array<Boleto>; fecha: string; carrito: string } = {
    boletos: [],
    fecha: '',
    carrito: '',
  };
  public boletos_p_liberar: { boletos: Array<Boleto>; fecha: string; orden: string; carrito: string } = {
    boletos: [],
    fecha: '',
    orden: '',
    carrito: '',
  };
  public boletos: Array<Boleto> = [];
  public total_compra: number = 0;
  public bolCola: number = 0;
  public tipos_pago: number;
  public spinner: boolean = false;
  public carrito: string;

  flagEgresado: boolean = false;
  flagVentaCruzada: boolean = false;

  // ── Modal de bloqueo (sin salida) ────────────────────────────────────────────
  // OJO: el modal es SOLO informativo. La protección real es que bloqueaCarrito()
  // borra localStorage y sessionStorage ANTES de mostrarlo: si alguien elimina el
  // modal con el inspector, se queda en una página ya vacía (sin boletos, sin
  // comprador, sin carrito) y no puede avanzar. Además el backend vuelve a validar
  // en PreventaPublicoGeneralBanco. Por eso primero se limpia y luego se muestra.
  public modalBloqueo: boolean = false;
  public modalTitulo: string = '';
  // Un renglón por boleto, con el mensaje completo que arma el backend, ya partido
  // en tres para poder pintar el folio en negrita:  "El boleto " + <b>068402</b> + " ya tiene..."
  // Se parte aquí (no en el template) para no recalcularlo en cada ciclo de Angular.
  public modalMensajes: Array<{ pre: string; folio: string; post: string }> = [];
  private modalRedirectTimer: any = null;
  // Red de seguridad: si el modal se elimina con el inspector, igual manda al home.
  private readonly MODAL_AUTO_REDIRECT_MS = 15000;

  // ── Modal de límite por transacción (sí se cierra: el usuario puede quitar boletos) ──
  public modalLimite: boolean = false;
  public limiteMontoMaximo: number = 0;
  public validandoLimite: boolean = false;


  constructor(
    private myGetService: MyHttpGetService,
    private _session: SessionstorageService,
    private _local: LocalstorageService,
    private router: Router,
    public st: TimerService,
    private _BColaboradoresService: BoletosColaboradoresService,
    private readonly _stripePagoService: StripePagoService,
  ) {
    var lsRecomendados = this._local.getBoletosRecomendados();
    var lsGenerados = this._local.getBoletosGenerados();
    var lsAsignados = this._local.getBoletosAsignados();
    var lsBloqueados = this._local.getBoletosBloqueados();
    var lsCarrito = this._local.getCarrito();
    var lsbolCol = this._session.getBoletosCol();
    this.bolCola = lsbolCol ? parseInt(lsbolCol) : 0;
    this.boletos_generados = lsGenerados == null ? [] : JSON.parse(lsGenerados);
    this.boletos_recomendados = lsRecomendados == null ? [] : JSON.parse(lsRecomendados);
    this.boletos_asignados = lsAsignados == null ? [] : JSON.parse(lsAsignados);
    this.boletos_bloqueados_local = lsBloqueados == null ? [] : JSON.parse(lsBloqueados);
    this.tipos_pago = parseInt(this._session.getTiposPago());
    this.carrito = lsCarrito;
  }

  async ngOnInit() {
    this.spinner = false;
    this.verificaCarrito();
    await this.getData(this.boletos_generados, this.boletos_recomendados, this.boletos_asignados);
    let folio = this.boletos.map(boleto => boleto.folio).join(',');

    this._BColaboradoresService.validarBoletosFisico({ folios: folio }).subscribe(
      (resultado: { [key: string]: boolean }) => {
        const todosTrue = Object.values(resultado).every(valor => valor === true);

        if (todosTrue) {
          console.log("ninguno es físico, continuando con el proceso de pago...");
        } else {
          const fisicos = Object.entries(resultado)
            .filter(([folio, disponible]) => !disponible)
            .map(([folio]) =>
              this.partirMensaje(
                `El boleto ${folio} es físico y no puede pagarse por este medio.`,
                folio
              )
            );

          this.bloqueaCarrito('Boletos no disponibles en línea', fisicos);
        }
      },
      err => {
        this.bloqueaCarrito('No pudimos validar tus boletos', [
          this.partirMensaje('Tuvimos un problema de conexión al validar tus boletos.', ''),
          this.partirMensaje('Por favor vuelve a intentarlo desde el inicio.', ''),
        ]);
      }
    );


    if (sessionStorage.getItem('pk_boleto_app') !== '1') {
      // La API responde una LISTA con el motivo por folio:
      //   [{ folio, valido, motivo, mensaje }]
      // motivo: OK | VENDIDO | PAGADO | EN_CARRITO | TARJETA | PAYPAL | REFERENCIA | OXXO |
      //         SPEI | LIGA | NO_DIGITAL | NO_EXISTE
      // 'mensaje' ya viene listo para mostrar (incluye la hora de liberación), por eso aquí
      // no se arma el texto.
      //
      // Se manda idCarrito: es el carrito de ESTE usuario. Sin él, el backend lo bloquearía
      // con su propia reserva, porque esta validación corre DESPUÉS de que ya apartó
      // los boletos (ActualizaCarroBoletos en getData). Con él, solo bloquea si el boleto
      // está en el carrito de alguien más.
      const miCarrito = this.carrito || this._local.getCarrito() || '';
      this._BColaboradoresService.validarBoletosODC({ folios: folio, idCarrito: miCarrito }).subscribe(
        (resultado: Array<{ folio: string; valido: boolean; motivo: string; mensaje: string }>) => {
          const invalidos = (resultado || []).filter((r) => !r.valido);

          if (invalidos.length === 0) {
            // Lógica de éxito: los boletos están disponibles para proceso
            console.log('Validación correcta. Continuando...');

            // REGLA: el carrito manda, y va PRIMERO. Hasta esta linea no se sabia si
            // el boleto era de este comprador o estaba en el carrito de alguien mas.
            // Por eso la cancelacion del intento de Stripe se hace AQUI y no antes:
            // si se hiciera antes, a un comprador que esta pagando en este momento le
            // cancelariamos su intento solo porque otro entro a ver el mismo boleto.
            //
            // Con Stripe se puede reintentar las veces que sea (a diferencia de MIT, que
            // bloquea 24 h): se cancela el intento anterior y la orden pasa a PR. Si el
            // backend responde que NO se puede continuar —porque ese pago SI se cobro y
            // solo falta que llegue el webhook— el propio metodo muestra el modal y
            // corta la compra: dejarlo pagar otra vez seria cobrarle dos veces.
            this.cancelarIntentosPreviosStripe();
          } else {
            // Un renglón por boleto, cada uno con su motivo real y el folio en negrita.
            const detalle = invalidos.map((r) =>
              this.partirMensaje(
                r.mensaje || `El boleto ${r.folio} no está disponible.`,
                r.folio
              )
            );
            this.bloqueaCarrito('No podemos apartar estos boletos', detalle);
          }
        },
        error => {
          this.bloqueaCarrito('No pudimos validar tus boletos', [
            this.partirMensaje('Tuvimos un problema de conexión al validar tus boletos.', ''),
            this.partirMensaje('Por favor vuelve a intentarlo desde el inicio.', ''),
          ]);
        }
      );

    }







    //valida boletos en ordén de compra
    //  this._BColaboradoresService.validarBoletosODC({ folios: folio }).subscribe(
    //   (resultado: { [key: string]: boolean }) => {
    //     const todosTrue = Object.values(resultado).every(valor => valor === true);

    //     if (todosTrue) {

    //     } else {
    //       const foliosNoDisponibles = Object.entries(resultado)
    //         .filter(([folio, disponible]) => !disponible)
    //         .map(([folio]) => folio)
    //         .join(', ');

    //       alert(`El/Los boleto(s) ${foliosNoDisponibles} son físicos y no puedes pagarlos por este medio.`);
    //       // Limpiar almacenamiento local y de sesión
    //       localStorage.clear();
    //       sessionStorage.clear();

    //       // Redirigir a otra página (por ejemplo, a la página principal)
    //       window.location.href = 'error-pago?success=false&nbResponse=Invalido';
    //     }
    //   },
    //   err => {
    //     alert('Error en la validación de folios. Intente nuevamente.');
    //     // Limpiar almacenamiento local y de sesión
    //     localStorage.clear();
    //     sessionStorage.clear();

    //     // Redirigir a otra página (por ejemplo, a la página principal)
    //     window.location.href = 'error-pago?success=false&nbResponse=Invalido';
    //   }
    // );



    if (this.tipos_pago == 1) {
      this.st.startTimer();
    }
    this._local.deleteFolio();
    /// Pop up
    var popC = this._session.getPopstate();
    //////console.log(popC);
    //this.PopupAmigable(popC);
    let pageInfo: string | null;
    pageInfo = sessionStorage.getItem('url');
    if (pageInfo === 'home-egresados' || pageInfo === 'egresados-lealtad') this.flagEgresado = true;
    //
    // let infoEgr: string | null;
    // infoEgr = sessionStorage.getItem('infoEgr');
    // const expectedHashOfOne = CryptoJS.MD5('1').toString();
    // let jem: string | null;
    // jem = sessionStorage.getItem('jem');
    // let todosMismoCosto = true;
    // const primerCosto = this.boletos[0].costo;

    // let hayCostoDiferente = false;
    // // if (infoEgr === null || infoEgr === undefined || jem === null || jem === undefined) window.location.href = 'error-pago?success=false&nbResponse=Invalido'; else this.flagEgresado = true;
    // if (sessionStorage.getItem('venta_cruzada') === 'true') this.flagVentaCruzada = true;
    // if (infoEgr === expectedHashOfOne) {
    //   sessionStorage.setItem('step2', CryptoJS.MD5('2').toString());
    //   this.flagEgresado = true;
    //   this.boletos.forEach(boleto => {
    //     if (boleto.costo !== primerCosto) {
    //       hayCostoDiferente = true;
    //       // console.log(`Diferencia detectada: ${boleto.costo} vs ${primerCosto}`); // Para depuración
    //     }
    //   });

    //   if (hayCostoDiferente) {
    //     todosMismoCosto = false; // Actualiza la bandera para el *ngIf
    //     window.location.href = 'error-pago?success=false&nbResponse=CarritoDuplicado';
    //   } else {
    //     todosMismoCosto = true; // Todos los boletos tienen el mismo costo

    //   }
    // } else {
    //   this.boletos.forEach(boleto => {
    //     if (boleto.costo !== primerCosto) {
    //       hayCostoDiferente = true;
    //       // console.log(`Diferencia detectada: ${boleto.costo} vs ${primerCosto}`); // Para depuración
    //     }
    //   });

    //   if (hayCostoDiferente) {
    //     todosMismoCosto = false; // Actualiza la bandera para el *ngIf
    //     window.location.href = 'error-pago?success=false&nbResponse=Invalido';
    //   } else {
    //     todosMismoCosto = true; // Todos los boletos tienen el mismo costo

    //   }
    // }
    const primerCosto = this.boletos[0].costo;
    this.boletos.forEach(boleto => {
      if (boleto.costo !== primerCosto) {
        window.location.href = 'error-pago?success=false&nbResponse=CarritoDuplicado';
        return;
      }
    });



  }

  /**
   * Cancela el intento de pago anterior de cada boleto del carrito, para que el comprador
   * pueda volver a pagar con Stripe sin esperar.
   *
   * Devuelve false si hay que DETENER el flujo (y ya dejo el modal puesto). Eso pasa cuando:
   *   YA_PAGADO    - el pago anterior si se cobro; pagar de nuevo seria cobro doble
   *   EN_PROCESO   - Stripe lo esta cobrando ahora; que espere unos minutos
   *   ERROR_STRIPE - no se pudo verificar con Stripe; que intente mas tarde
   *
   * Si el endpoint no responde (red, servicio abajo) se DEJA PASAR: la validacion de
   * ValidarFoliosReferencia sigue protegiendo el boleto, y las confirmaciones de pago
   * tienen su propia puerta (ValidaOrdenNoPagada). No vale la pena tumbar la compra por esto.
   */
  private async cancelarIntentosPreviosStripe(): Promise<boolean> {
    const folios = (this.boletos || [])
      .map((b: any) => (b.folio || '').toString().trim())
      .filter((f: string) => f.length > 0);

    if (folios.length === 0) return true;

    const bloqueos: Array<{ folio: string; razon: string }> = [];

    for (const f of folios) {
      try {
        const r: any = await this._stripePagoService.cancelarIntentPrevio(f).toPromise();
        if (r && r.puedeContinuar === false) {
          bloqueos.push({ folio: f, razon: r.mensaje || 'No se pudo continuar con este boleto.' });
        }
      } catch (e) {
        // Falla de red/servicio: se deja pasar (ver comentario del metodo).
        console.warn('[carrito] No se pudo cancelar el intent previo del boleto ' + f, e);
      }
    }

    if (bloqueos.length > 0) {
      this.bloqueaCarrito(
        'No podemos continuar con tu compra',
        bloqueos.map((b) => this.partirMensaje(b.razon, b.folio))
      );
      return false;
    }

    return true;
  }

  /**
   * Corta la compra y muestra el modal sin salida.
   * El ORDEN importa: primero se destruye el estado, después se informa.
   * Así, aunque borren el modal con el inspector, ya no hay nada con que continuar.
   */
  /**
   * Parte el mensaje en tres para poder resaltar el folio:
   *   "El boleto 068402 ya tiene un pago." → { pre:"El boleto ", folio:"068402", post:" ya tiene un pago." }
   * Si no hay folio o no aparece en el texto, todo se va a 'pre' y se pinta normal.
   */
  private partirMensaje(texto: string, folio: string): { pre: string; folio: string; post: string } {
    if (!folio) return { pre: texto, folio: '', post: '' };
    const i = texto.indexOf(folio);
    if (i === -1) return { pre: texto, folio: '', post: '' };
    return { pre: texto.substring(0, i), folio: folio, post: texto.substring(i + folio.length) };
  }

  private bloqueaCarrito(
    titulo: string,
    mensajes: Array<{ pre: string; folio: string; post: string }>
  ) {
    // Las dos validaciones (físicos y orden de compra) corren en paralelo, así que esto
    // puede dispararse dos veces. La primera manda: la segunda solo suma sus mensajes,
    // sin volver a liberar boletos ni reiniciar el contador de regreso al inicio.
    if (this.modalBloqueo) {
      mensajes.forEach((m) => {
        const repetido = this.modalMensajes.some(
          (x) => x.pre === m.pre && x.folio === m.folio && x.post === m.post
        );
        if (!repetido) this.modalMensajes.push(m);
      });
      return;
    }

    // 1) Detener el timer ANTES que nada. Si no, al borrar el storage se queda sin
    //    fechaFin, cree que la sesión expiró y navega al home al siguiente segundo,
    //    cerrando este modal antes de que se alcance a leer.
    this.st.detener();

    // 2) Devolver los boletos que getData() ya había apartado en BD. Esto va ANTES de
    //    limpiar, porque LiberaBoletos necesita el carrito y los boletos del storage.
    //    Sin esto el boleto se queda apartado aunque la compra se haya cortado.
    this.liberaBoletosApartados();

    // 3) La protección: matar el estado antes de pintar nada.
    localStorage.clear();
    // La liga de colaborador se conserva: si el boleto ya no estaba disponible, el
    // comprador debe poder volver a la liga y elegir OTRO, no quedarse sin salida.
    this._local.limpiarCompra();

    // 4) El aviso (solo informativo).
    this.modalTitulo = titulo;
    this.modalMensajes = mensajes;
    this.modalBloqueo = true;
    this.spinner = true;

    // 5) Red de seguridad por si eliminan el modal del DOM.
    if (this.modalRedirectTimer) clearTimeout(this.modalRedirectTimer);
    this.modalRedirectTimer = setTimeout(() => this.regresaHome(), this.MODAL_AUTO_REDIRECT_MS);
  }

  /**
   * Libera en BD los boletos que este carrito acababa de apartar (ActualizaCarroBoletos
   * corre en getData(), ANTES de las validaciones). Si no se liberan, el boleto queda
   * apartado y al reintentar aparece "en carrito" hasta que el job de cada minuto lo suelte.
   */
  private liberaBoletosApartados() {
    try {
      const carritoId = this.carrito || this._local.getCarrito();
      const aLiberar = [...(this.boletos_bloqueados.boletos || []), ...(this.boletos_bloqueados_local || [])];

      if (!carritoId || aLiberar.length === 0) return;

      this.boletos_p_liberar.boletos = aLiberar;
      this.boletos_p_liberar.fecha = new Date().toISOString();
      this.boletos_p_liberar.carrito = carritoId;
      this.boletos_p_liberar.orden = this._local.getFolio() || '';

      this.myGetService
        .postData(this.boletos_p_liberar, 'api/BoletosWeb/LiberaBoletos')
        .subscribe(() => {}, () => {});
    } catch (e) {
      // Nunca dejar que un fallo al liberar impida mostrar el aviso.
      console.error('[carrito] No se pudieron liberar los boletos apartados:', e);
    }
  }

  /** Único botón del modal: vuelve al inicio (ya NO va a error-pago). */
  public regresaHome() {
    if (this.modalRedirectTimer) {
      clearTimeout(this.modalRedirectTimer);
      this.modalRedirectTimer = null;
    }
    localStorage.clear();
    // La liga de colaborador se conserva: si el boleto ya no estaba disponible, el
    // comprador debe poder volver a la liga y elegir OTRO, no quedarse sin salida.
    this._local.limpiarCompra();
    window.location.href = 'compra-en-linea-boletos-sorteo-anahuac';
  }

  ngOnDestroy() {
    if (this.modalRedirectTimer) clearTimeout(this.modalRedirectTimer);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    };
    return date.toLocaleDateString('es-ES', options);
  }

  verificaCarrito(): void {
    let boletosl: Boleto[] = this.bolCola == 0 ? this.boletos_recomendados : this.boletos_generados;

    // Esta purga es SOLO de pantalla: publico general (bolCola=0) y liga de
    // colaborador (bolCola=1) son excluyentes, asi que al entrar en un modo se
    // limpia la lista del otro.
    //
    // Antes llamaba a LiberaBoletos y soltaba la reserva EN LA BASE. Como la liga
    // de colaborador usa tipos_pago = 1, eso libero boletos que ya tenian una
    // orden viva: el comprador sacaba su referencia (u OXXO/SPEI), se iba al home
    // sin darle a Terminar, agregaba otro boleto y al volver aqui se borraba
    // BOLETOS.Carrito y el renglon de CARRITO de su boleto ya pagado. Quedaba el
    // papel valido varios dias y el boleto libre para que otro lo rotulara.
    //
    // Por eso va liberarEnServidor = false: se limpia pantalla y storage, y el
    // boleto abandonado lo suelta el job de carrito.
    // El botecito de basura (accion del usuario) sigue liberando igual que antes.
    boletosl.forEach((boleto) => {
      this.deleteBoleto(boleto, false);
    });
  }


  async getData(
    boletos_generados: Array<Boleto>,
    boletos_recomendados: Array<Boleto>,
    boletos_asignados: Array<Boleto>
  ) {
    //debugger;
    var fechaFin = new Date(this._local.getFechaFin()); //Fecha en que se limpia el carrito
    var fechaInicio = new Date(this._local.getFechaInicio()); //Fecha en que se agrego el boleto al carrito
    var seconds = fechaFin.getTime() - fechaInicio.getTime(); // Timer

    if (this.tipos_pago == 1) {
      if (boletos_generados !== []) {
        boletos_generados.sort(function (a, b) {
          return a.folio - b.folio;
        });

        for (var i = 0; i <= boletos_generados.length - 1; i++) {
          this.total_compra = this.total_compra + boletos_generados[i].costo;
          this.boletos.push(boletos_generados[i]);
        }
      }

      if (boletos_recomendados !== []) {
        boletos_recomendados.sort(function (a, b) {
          return a.folio - b.folio;
        });
        for (var i = 0; i <= boletos_recomendados.length - 1; i++) {
          this.total_compra = this.total_compra + boletos_recomendados[i].costo;
          this.boletos.push(boletos_recomendados[i]);
        }
      }
      ////console.log(fechaFin);
      this.boletos_bloqueados.boletos =
        this.boletos_generados.length > 0 ? this.boletos_generados : this.boletos_recomendados;
      if (this.boletos_bloqueados_local.length > 0) {
        this.boletos_bloqueados_local.forEach((boleto) => {
          this.boletos_bloqueados.boletos = this.boletos_bloqueados.boletos.filter((b) => b.clave !== boleto.clave);
        });
      }

      this.boletos_bloqueados.fecha = fechaFin.toISOString();
      this.boletos_bloqueados.carrito = this.carrito;
      ////console.log(this.boletos_bloqueados);

      if (this.boletos_bloqueados.boletos.length > 0) {
        return new Promise((resolve, reject) => {
          this.myGetService.postData(this.boletos_bloqueados, 'api/BoletosWeb/ValidaBoletosPagoMIT').subscribe(
            (res) => {
              this.myGetService.postData(this.boletos_bloqueados, 'api/BoletosWeb/ActualizaCarroBoletos').subscribe(
                (res) => {
                  ////console.log(res);
                  if (res.ok) {
                    if (!this.carrito) {
                      this.carrito = res.json();
                      this._local.setCarrito(this.carrito);
                    }
                    this.spinner = true;
                    this.boletos_bloqueados.boletos = [
                      ...this.boletos_bloqueados.boletos,
                      ...this.boletos_bloqueados_local,
                    ];
                    this._local.setBoletosBloqueados(this.boletos_bloqueados.boletos);
                    this.boletos_bloqueados_local = this.boletos_bloqueados.boletos;
                    resolve('Promise complete');
                  }
                },
                (error) => {
                  console.log(error);
                  //validar que este en carrito o mandar error
                  window.location.href = 'error-pago?success=false&nbResponse=ErrorDatosCarrito';
                }
              );
            },
            (err) => {
              window.location.href = 'error-pago?success=false&nbResponse=Invalido';
            }
          );
        });
      } else {
        this.spinner = true;
      }
    } else {
      if (boletos_asignados !== []) {
        return new Promise((resolve, reject) => {
          this.boletos_bloqueados.boletos = boletos_asignados;
          this.boletos_bloqueados.fecha = fechaFin.toISOString();
          this.boletos_bloqueados.carrito = '';
          this.myGetService.postData(this.boletos_bloqueados, 'api/BoletosWeb/ValidaBoletosPagoMIT').subscribe(
            (res) => {
              this._session.setContCarrito(1);
              boletos_asignados.sort(function (a, b) {
                return a.folio - b.folio;
              });
              for (var i = 0; i <= boletos_asignados.length - 1; i++) {
                this.total_compra = this.total_compra + boletos_asignados[i].costo;
                this.boletos.push(boletos_asignados[i]);
              }

              this.spinner = true;
              resolve('Promise complete');
            },
            (err) => {
              window.location.href = 'error-pago?success=false&nbResponse=Invalido';
            }
          );
        });
      }
    }
  }

  async efectuarPago() {
    if (this.validandoLimite) return;

    // Límite máximo por transacción: solo se mandan los folios, APIs Pagos suma
    // BOLETOS.COSTO en BD (el costo del storage no se usa). Si la API falla, deja pasar.
    this.validandoLimite = true;
    const folios = (this.boletos || []).map((b) => (b.folio ?? '').toString());
    const limite = await this._stripePagoService.validarMonto(folios);
    this.validandoLimite = false;

    if (limite.activo && !limite.permitido) {
      this.limiteMontoMaximo = limite.montoMaximo;
      this.modalLimite = true;
      return;
    }

    if (this.tipos_pago == 2 || this.tipos_pago == 3) {
      this.router.navigate(['forma-pago']);
    } else {
      this.router.navigate(['datos-comprador']);
    }
  }

  regresar() {
    if (this.tipos_pago == 2 || this.tipos_pago == 3) {
      this.router.navigate(['login']);
    } else {
      this.router.navigate(['compra-en-linea-boletos-sorteo-anahuac']);
    }
  }

  deleteBoleto = (boleto: Boleto, liberarEnServidor: boolean = true): void => {
    this.boletos = this.boletos.filter((b) => b.clave !== boleto.clave);
    this.boletos_generados = this.boletos_generados.filter((b) => b.clave !== boleto.clave);
    this.boletos_recomendados = this.boletos_recomendados.filter((b) => b.clave !== boleto.clave);
    this.boletos_asignados = this.boletos_asignados.filter((b) => b.clave !== boleto.clave);
    this.boletos_bloqueados_local = this.boletos_bloqueados_local.filter((b) => b.clave !== boleto.clave);
    this._local.setBoletosGenerados(this.boletos_generados);
    this._local.setBoletosRecomendados(this.boletos_recomendados);
    this._local.setBoletosAsignados(this.boletos_asignados);
    this._local.setBoletosBloqueados(this.boletos_bloqueados_local);
    if (this.total_compra > 0) {
      this.total_compra = this.total_compra - boleto.costo;
    }

    this.boletos_p_liberar.boletos[0] = boleto;
    this.boletos_p_liberar.fecha = new Date().toISOString();
    if (this.tipos_pago == 1 && liberarEnServidor) {
      this.boletos_p_liberar.carrito = this.carrito;
      this.myGetService.postData(this.boletos_p_liberar, 'api/BoletosWeb/LiberaBoletos').subscribe((res) => {
        //////console.log("response");
        //////console.log(res);
      });
      if (this.boletos_bloqueados_local.length == 0) {
        this._local.deleteCarrito();
        this.carrito = '';
      }
    }
  };

  //// ------------ POPUP------------
  /*
  PopupAmigable(popC) {
    var PopAct = document.getElementById('popupamigable');
    if (popC == 0) {
      setTimeout(() => {
        document.addEventListener('mouseout', (event) => {
          if (event.relatedTarget === null && popC == 0) {
            PopAct.hidden = false;
            popC = 2;
            this._session.setPopstate(popC);
          }
        });
      }, 5);
    } else {
      PopAct.hidden = true;
    }
  }
*/

}
